import {bignumber, BigNumber} from "mathjs";

export interface CommodityGroup {
  name: string;
  kgm3Limits: [BigNumber, BigNumber]
  kgm3At60Limits: [BigNumber, BigNumber]
}

export const CommodityGroupCrudeOil: CommodityGroup = {
  name: "Crude Oil",
  kgm3Limits: [bignumber("470.5"), bignumber("1201.8")],
  kgm3At60Limits: [bignumber("610.6"), bignumber("1163.5")]
}

export const CommodityGroupRefinedProducts: CommodityGroup = {
  name: "Refined Products",
  kgm3Limits: [bignumber("470.4"), bignumber("1209.5")],
  kgm3At60Limits: [bignumber("610.6"), bignumber("1163.5")]
}

export const CommodityGroupLubricatingOil: CommodityGroup = {
  name: "Lubricating Oil",
  kgm3Limits: [bignumber("714.3"), bignumber("1208.3")],
  kgm3At60Limits: [bignumber("800.9"), bignumber("1163.5")]
}

export const commodityGroups = {
  crudeOil: CommodityGroupCrudeOil,
  refinedProducts: CommodityGroupRefinedProducts,
  lubricatingOil: CommodityGroupLubricatingOil
}
